export default function GenerateReportsListController(
  $q,
  generateReportsDialog,
  loaderService,
  reportsDataService,
  ssDialogService
) {
  const vm = this;

  vm.handleOpenGenerateReportsPopoutClick = handleOpenGenerateReportsPopoutClick;

  function handleOpenGenerateReportsPopoutClick($event) {
    const dfdOpenPopout = $q.defer();

    loaderService.showViewLoader = true;
    if (vm.serviceId !== undefined) {
      reportsDataService.getReportsByService(vm.serviceId).then((getReportsResponse) => {
        ssDialogService.dialogs.global.generateReportsDialog = ssDialogService.alert(
          generateReportsDialog.getOptions($event, {
            reports: getReportsResponse.data.result,
            serviceId: vm.serviceId,
            customerId: vm.customerId,
            atCustId: vm.atCustId,
            usesFilter: vm.usesFilter,
            usesFocus: vm.usesFocus,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.global.generateReportsDialog);
        loaderService.showViewLoader = false;
        dfdOpenPopout.resolve();
      });
    } else {
      reportsDataService.getReportsByGroup(vm.groupId).then((getReportsResponse) => {
        ssDialogService.dialogs.global.generateReportsDialog = ssDialogService.alert(
          generateReportsDialog.getOptions($event, {
            reports: getReportsResponse.data.result,
            groupId: vm.groupId,
            customerId: vm.customerId,
            atCustId: vm.atCustId,
            usesFilter: vm.usesFilter,
            usesFocus: vm.usesFocus,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.global.generateReportsDialog);
        loaderService.showViewLoader = false;
        dfdOpenPopout.resolve();
      });
    }
    return dfdOpenPopout.promise;
  }
}

GenerateReportsListController.$inject = [
  '$q',
  'generateReportsDialog',
  'loaderService',
  'reportsDataService',
  'ssDialogService'
];
